import React from 'react';

function Icon({ icon, className }) {
    return (
        <i className={`fa fa-${icon} ${className}`} aria-hidden="true"></i>
    )
}

export default Icon;
